import { useTranslation } from "react-i18next";

const AgentRoleOptions = (list) => {
  const { t } = useTranslation();
  const options = [
    {
      key: "SUPER_ADMIN",
      title: t("options.agentrole.super_admin"),
      value: "SUPER_ADMIN",
    },
    {
      key: "PF_ADMIN",
      title: t("options.agentrole.pf_admin"),
      value: "PF_ADMIN",
    },
    {
      key: "PF_USER",
      title: t("options.agentrole.pf_user"),
      value: "PF_USER",
    },
    {
      key: "PF_MERCHANT",
      title: t("options.agentrole.pf_merchant"),
      value: "PF_MERCHANT",
    },
  ];

  if (typeof list === "string" && list.toLowerCase() === "all") {
    return options;
  }
  if (Array.isArray(list)) {
    const newOptions = [];
    for (const item of list) {
      const newOption = options.find(
        (option) => item === option.value || item === option.key.toLowerCase(),
      );
      newOptions.push(newOption);
    }
    return newOptions;
  }
  return [];
};

export default AgentRoleOptions;
